// @flow
import { createSelector } from 'reselect';
import dashboardItemPositionById from './dashboardItemPositionById';
import { fromJS } from 'immutable';
import { getIdFromProps } from '~/core/state/selectors';
import { getProductItems } from '~/core/state/products/selectors';
import nextAvailableProductSlot from './nextAvailableProductSlot';

const minProductLength = 1;

const getDashboard = state => state.dashboard;

export const getCurrentDashboardPage = createSelector([getDashboard], dashboard => dashboard.get('currentPage'));

export const getIsDashboardFetching = createSelector([getDashboard], dashboard => !!dashboard.get('isFetching'));

export const getIsCustomisationLoaded = createSelector([getDashboard], dashboard => !!dashboard.get('isLoaded'));

export const getDashboardCustomisation = createSelector([getDashboard], dashboard => dashboard.get('customisation'));

export const getLastSwappedProduct = createSelector([getDashboard], dashboard => dashboard.get('lastProductSwapped'));

export const getIsShowingAllProducts = createSelector([getDashboard], dashboard =>
    dashboard.get('displayAllProducts', false)
);

export const getDashboardGroups = createSelector([getDashboardCustomisation], customisation =>
    customisation.get('pages', fromJS([]))
);

export const getIsDashboardEditModeOn = createSelector([getDashboard], dashboard => dashboard.get('isEditModeOn'));

export const getIdsToBeDeleted = createSelector([getDashboard], dashboard => dashboard.get('idsToBeDeleted'));

export const getLastPageItemCount = createSelector([getDashboardGroups], (pages = fromJS([])) =>
    // $FlowFixMe
    pages.getIn([-1, 'items'], fromJS([])).count()
);

export const getLastPageLastItemId = createSelector([getDashboardGroups], (pages = fromJS([])) =>
    // $FlowFixMe
    pages.getIn([-1, 'items', -1, 'id'])
);

export const getAvailableProductsForCustomisation = createSelector(
    [getDashboardGroups, getProductItems],
    (customisationGroups, products) => {
        if (!customisationGroups) {
            return;
        }
        const usedIds = customisationGroups.flatMap(page => page.get('items')).map(item => item.get('id'));
        return products.map(p => p.get('id')).filter(p => !usedIds.some(u => u === p));
    }
);

export const getHasAvailableProductsForCustomisation = createSelector(
    [getAvailableProductsForCustomisation],
    products => (products ? products.count() > 0 : false)
);

export const getIsDashboardAddModeOn = createSelector([getDashboard], dashboard => dashboard.get('isAddModeOn'));

export const getNextAvailableProductSlot = createSelector([getDashboardGroups], nextAvailableProductSlot);

export const getCurrentDashboardProductsLength = createSelector([getDashboardGroups], pages =>
    pages.flatMap(page => page.get('items')).count()
);

export const getCanDeleteProduct = createSelector(
    [getCurrentDashboardProductsLength],
    productsLength => productsLength > minProductLength
);

export const getHasUnsavedChanges = createSelector([getDashboard], dashboard => dashboard.get('hasUnsavedChanges'));

export const getLastProductAdded = createSelector([getDashboard], dashboard => dashboard.get('lastProductAdded'));

// $FlowFixMe
export const getDashboardItemPositionById = createSelector(
    getDashboardGroups,
    getIdFromProps,
    dashboardItemPositionById
);

export const getShouldRedirectToPostinstallGroups = createSelector(getDashboard, dashboard =>
    dashboard.get('shouldRedirectToPostinstallGroups')
);



// WEBPACK FOOTER //
// ./src/core/state/dashboard/selectors.js